export const VI = "vi";
export const EN = "en";
